export function parseFileNameType(file: string) {
	const temp = file.split(".");
	const fileType = temp[temp.length - 1];
	const fileName = file.replace(`.${fileType}`, "");
	return { fileName: fileName, fileType: fileType };
}
